/**
 * Merge a PATCH/POST cart API payload into the in-memory checkout cart without
 * dropping line items when the response omits `order_offers` (CartResource uses
 * whenLoaded and can omit the key if relations were not hydrated).
 */
export const mergeCartApiPayload = (previousCart, incomingCart) => {
	if (!incomingCart || typeof incomingCart !== 'object') {
		return previousCart ?? incomingCart;
	}

	if (!previousCart || typeof previousCart !== 'object') {
		return incomingCart;
	}

	const merged = { ...previousCart, ...incomingCart };
	const previousOffers = previousCart.order_offers;

	// Preserve line items only when the API omitted the key (whenLoaded / partial payload).
	// An explicit empty array is a legitimate empty cart — do not keep stale offers.
	if (
		!Object.prototype.hasOwnProperty.call(incomingCart, 'order_offers')
		&& Array.isArray(previousOffers)
		&& previousOffers.length > 0
	) {
		merged.order_offers = previousOffers;
	}

	return merged;
};
